import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, X, ExternalLink } from "lucide-react";
import api from "../lib/api";

// Popup laporan teknisi dari absensi.deteksipipabocor.com (tombol Selesai/Gagal di Jadwal Hari Ini).
const TechReportPopup = () => {
  const nav = useNavigate();
  const location = useLocation();
  const [reports, setReports] = useState([]);

  const load = useCallback(() => {
    api.get("/tech-reports/pending").then((r) => setReports(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const iv = setInterval(load, 20000);
    return () => clearInterval(iv);
  }, [load]);

  const ack = async (r) => {
    setReports((prev) => prev.filter((x) => x.id !== r.id));
    try { await api.post(`/tech-reports/${r.id}/ack`); } catch (_) { /* noop */ }
  };

  const openOrder = async (r) => {
    await ack(r);
    const url = `/orders?open=${encodeURIComponent(r.order_id)}`;
    // Halaman Order hanya membaca ?open= saat dimuat, jadi reload penuh jika sudah di /orders
    if (location.pathname === "/orders") window.location.assign(url);
    else nav(url);
  };

  if (!reports.length) return null;
  const r = reports[0];
  const ok = r.status === "selesai";
  const color = ok ? "#059669" : "#DC2626";

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" data-testid="tech-report-popup">
      <div className="bg-white w-full max-w-md border-2 shadow-2xl" style={{ borderColor: color }}>
        <div className="flex items-center justify-between px-4 py-3 text-white" style={{ backgroundColor: color }}>
          <div className="flex items-center gap-2 font-heading font-bold">
            {ok ? <CheckCircle2 size={20} /> : <XCircle size={20} />}
            Laporan Teknisi · {ok ? "SELESAI" : "GAGAL"}
          </div>
          <button onClick={() => ack(r)} className="p-1 hover:bg-white/20" aria-label="Tutup" data-testid="tech-report-close"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-2 text-sm">
          <p>
            Order <span className="font-mono font-bold text-[#002FA7]">{r.order_no}</span>
            {r.customer_name ? <> ({r.customer_name})</> : null} yang dikerjakan oleh{" "}
            <span className="font-bold">{r.technician_name}</span> statusnya{" "}
            <span className="font-bold" style={{ color }}>{ok ? "SELESAI" : "GAGAL"}</span>.
          </p>
          {r.note ? (
            <p className="text-[#52525B]"><span className="font-bold">{ok ? "Catatan" : "Alasan"}:</span> {r.note}</p>
          ) : null}
          <p className="text-xs text-[#52525B] font-mono">
            {(() => { try { return new Date(r.updated_at).toLocaleString("id-ID"); } catch (_) { return ""; } })()}
          </p>
          {reports.length > 1 && (
            <p className="text-xs text-[#52525B]">+{reports.length - 1} laporan lain menunggu</p>
          )}
        </div>
        <div className="flex gap-2 px-4 pb-4">
          <button onClick={() => openOrder(r)} data-testid="tech-report-open"
            className="flex-1 inline-flex items-center justify-center gap-2 bg-[#002FA7] text-white px-3 py-2 text-xs font-bold uppercase tracking-wider hover:bg-[#002FA7]/90">
            <ExternalLink size={14} /> {ok ? "Buka Order · Buat Invoice" : "Buka Detail Order"}
          </button>
          <button onClick={() => ack(r)} className="px-3 py-2 text-xs font-bold uppercase tracking-wider border border-[#E4E4E7] hover:bg-[#F4F4F5]">
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
};

export default TechReportPopup;
